export const DefaultLayoutTestIds = {
  HEADER_SIDEBAR_MENU: 'header-sidebar.menu',
  MENU_SIDEBAR_LOGOUT: 'header-sidebar.logout-button',
};
